import React from "react"

export const Menu = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32px" height="25px">
    <path d="M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z"></path>
  </svg>
)
